/**
 * <s-card-swatches>: on hover or focus of a color circle, previews that
 * colorway's photo in the surrounding product card; restores it on leave.
 */
class SCardSwatches extends HTMLElement {
  connectedCallback() {
    this.card = this.closest('li');
    this.img = this.card ? this.card.querySelector('img') : null;
    if (!this.img) return;
    this.original = { src: this.img.getAttribute('src'), srcset: this.img.getAttribute('srcset') };
    this.onEnter = (event) => {
      const link = event.target.closest('[data-swatch-src]');
      if (!link || !this.contains(link)) return;
      this.img.setAttribute('srcset', link.dataset.swatchSrcset || '');
      this.img.setAttribute('src', link.dataset.swatchSrc);
    };
    this.onLeave = () => {
      if (this.original.srcset) this.img.setAttribute('srcset', this.original.srcset);
      if (this.original.src) this.img.setAttribute('src', this.original.src);
    };
    this.addEventListener('pointerover', this.onEnter);
    this.addEventListener('focusin', this.onEnter);
    this.addEventListener('pointerleave', this.onLeave);
    this.addEventListener('focusout', this.onLeave);
  }

  disconnectedCallback() {
    this.removeEventListener('pointerover', this.onEnter);
    this.removeEventListener('focusin', this.onEnter);
    this.removeEventListener('pointerleave', this.onLeave);
    this.removeEventListener('focusout', this.onLeave);
  }
}

if (!customElements.get('s-card-swatches')) customElements.define('s-card-swatches', SCardSwatches);
